var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrevCategory1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 89,
    height: 96,
    viewBox: "0 0 89 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_165_23)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.13461 20.5714C2.31058 20.5714 0 18.2571 0 15.4286C0 12.6 2.31058 10.2857 5.13461 10.2857H63.3269V1.71429C63.3269 0.771429 64.0971 0 65.0385 0H71.8846C72.826 0 73.5962 0.771429 73.5962 1.71429V10.2857H83.8654C86.6894 10.2857 89 12.6 89 15.4286C89 18.2571 86.6894 20.5714 83.8654 20.5714H73.5962V92.5714H77.0192C77.9606 92.5714 78.7308 93.3429 78.7308 94.2857C78.7308 95.2286 77.9606 96 77.0192 96H59.9038C58.9625 96 58.1923 95.2286 58.1923 94.2857C58.1923 93.3429 58.9625 92.5714 59.9038 92.5714H63.3269V20.5714H46.2115V27.4286H54.7692C55.7106 27.4286 56.4808 28.2 56.4808 29.1429V46.2857C56.4808 47.2286 55.7106 48 54.7692 48H46.2115V54.8571H54.7692C55.7106 54.8571 56.4808 55.6286 56.4808 56.5714V73.7143C56.4808 74.6571 55.7106 75.4286 54.7692 75.4286H13.6923C13.1788 75.4286 12.6825 75.1886 12.3573 74.7771L5.51115 66.2057C5.01481 65.5714 5.01481 64.6971 5.51115 64.0629L12.3573 55.4914C12.6825 55.08 13.1788 54.84 13.6923 54.84H20.5385V47.9829H13.6923C13.1788 47.9829 12.6825 47.7429 12.3573 47.3314L5.51115 38.76C5.01481 38.1257 5.01481 37.2514 5.51115 36.6171L12.3573 28.0457C12.6825 27.6343 13.1788 27.3943 13.6923 27.3943H20.5385V20.5371H5.13461V20.5714ZM23.9615 54.8571H42.7885V48H23.9615V54.8571ZM23.9615 27.4286H42.7885V20.5714H23.9615V27.4286Z",
    fill: "#C9A662"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_165_23"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 89,
    height: 96,
    fill: "white",
    transform: "matrix(-1 0 0 1 89 0)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrevCategory1);
export default __webpack_public_path__ + "static/media/prev-category1.8595d29ad96942320066e8c96562ab75.svg";
export { ForwardRef as ReactComponent };